import { createContext } from "react";

// The outbound telephony API — the EXACT public surface useTelephony() has always
// returned, so power dialer (useDialSession) + click-to-call (LeadShow) are
// unchanged whether backed by the shared Device (desktop, via TelephonyProvider)
// or the standalone lazy Device (mobile / no provider).
export type CallState = "idle" | "connecting" | "ringing" | "open" | "closed" | "error";
export type CallOpts = { agentUserId?: string; sessionId?: string };
export type SmsArgs = { to: string; body: string; lead_id?: string; contact_id?: string };

export interface TelephonyApi {
  call: (to: string, leadId?: string, opts?: CallOpts) => Promise<void>;
  hangup: () => void;
  sendSms: (args: SmsArgs) => Promise<unknown>;
  callState: CallState;
  error: string | null;
  getCallSid: () => string | null;
}

// Present only under <TelephonyProvider> (desktop). useTelephony() prefers it and
// falls back to a standalone Device when absent. The inbound receiver UI is owned
// by the provider (rendered as a global overlay), not exposed here.
export const TelephonyContext = createContext<TelephonyApi | null>(null);
